<button *ngIf="!textfield" class="nrk-button" nbPopoverTrigger="noop" [nbPopover]="product" (click)="onClick($event)">{{icon}}</button>

<div *ngIf="textfield && trial !== null && trial !== undefined && !baseProduct" class="row">
  <div class="col-md-4"><label>{{title}}</label></div>
  <div class="col-md-8">
    <div class="form-group">
      <div class="top">
        <input  nbPopoverTrigger="noop" [nbPopover]="product" type="text" (click)="onClick($event)"
          class="form-control form-control-sm" [placeholder]="title" [ngModel]="value" readonly>
        <div class="closebtn">
          <button class="nrk-doc-button" (click)="value='---- All ----'; productSelected.emit(null)" title="clear">X</button>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="textfield && baseProduct">
  <table class="w-100">
    <tr><td>
      <input nbPopoverTrigger="noop" [nbPopover]="product" type="text" (click)="onClick($event)"
        [placeholder]="title" [ngModel]="getBp(value)" readonly [attr.disabled]="disabled ? true : null">
    </td><td style="border:none; width:1em">
      <button class="nrk-button" (click)="value=''; productSelected.emit(null)" title="clear" [attr.disabled]="disabled ? true : null">X</button>
    </td></tr>
  </table>
</div>

<ng-template #product>
  <div class="customer">
    <div style="width: 100%;padding-right:10px;">
      <ngx-doc-form-filter-select class="fullwidth" placeholder="Customer..." [(value)]="business" [options]="data.businessOptions"></ngx-doc-form-filter-select></div>
    <div><button class="nrk-button" (click)="onClosePopup()">Close</button></div>
  </div>

  <section class="container">
    <table>
      <thead>
        <tr class="sticky">
          <th>
            <div class="column-header">
              <div class="title"><a [routerLink]="[]" (click)="onSort('nrkName')">Nipponrika&nbsp;product&nbsp;name</a></div>
              <div class="filter"><input placeholder="Search..." [(ngModel)]="searchNrkProductName" /></div>
            </div>
          </th>
          <th>
            <div class="column-header">
              <div class="title"><a [routerLink]="[]" (click)="onSort('trial')">Trial&nbsp;code</a></div>
              <div class="filter"><input placeholder="Search..." [(ngModel)]="searchTrial" /></div>
            </div>
          </th>
          <th>
            <div class="column-header">
              <div class="title"><a [routerLink]="[]" (click)="onSort('nrkCode')">Nipponrika&nbsp;code</a></div>
              <div class="filter"><input placeholder="Search..." [(ngModel)]="searchNrkCode" /></div>
            </div>
          </th>
          <th>
            <div class="column-header">
              <div class="title"><a [routerLink]="[]" (click)="onSort('customerName')">Customer&nbsp;product&nbsp;name</a></div>
              <div class="filter"><input placeholder="Search..." [(ngModel)]="searchCustomerProductName" /></div>
            </div>
          </th>
          <th>
            <div class="column-header">
              <div class="title"><a [routerLink]="[]" (click)="onSort('customerCode')">Customer&nbsp;code</a></div>
              <div class="filter"><input placeholder="Search..." [(ngModel)]="searchCustomerProductCode" /></div>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let fp of filter(searchNrkProductName,searchTrial,searchNrkCode,searchCustomerProductName,searchCustomerProductCode,business); let idx = index"
            (click)="onSelectRow(idx)">
          <td>{{fp.nrkName}}</td>
          <td>{{fp.trial}}</td>
          <td>{{fp.nrkCode}}</td>
          <td>{{fp.customerName}}</td>
          <td>{{fp.customerCode}}</td>
        </tr>
      </tbody>
    </table>
  </section>

</ng-template>

